import { useEffect } from "react"

type KeyboardEventType = 'keydown' | 'keyup'

export const useKeyboardEvent = (event: KeyboardEventType, callback: (key: string) => void) => {
  useEffect(() => {
    const handler = (event: KeyboardEvent) => callback(event.key)
    window.addEventListener(event, handler)
    return () => {
      window.removeEventListener(event, handler)
    }
  }, [event, callback])
}
